// Storage exceptions are swallowed at this layer because every caller in
// the app treats persistence as best-effort: when storage isn't available
// (iOS Safari Private Browsing throws QuotaExceededError on setItem;
// "Block All Cookies" / SecurityError; storage full) the session-only
// state in React/Redux is still correct. Letting these throws propagate
// caused a hard bug — onClick handlers that wrote to storage before
// flipping component state aborted mid-handler, leaving modals open and
// counters un-bumped on iOS incognito. Catching here keeps writes
// best-effort and reads safe.
const safeRun = (fn) => {
    try {
        return fn();
    } catch {
        return null;
    }
};

const localStorageStorageSource = {
    name: 'localStorageStorageSource',

    get(vname) {
        const val = safeRun(() => localStorage.getItem(vname));
        if (val) return safeRun(() => JSON.parse(val));
        return null;
    },
    add(vname, value) {
        if (value) {
            safeRun(() => localStorage.setItem(vname, JSON.stringify(value)));
        }
    },
    delete(vname) {
        safeRun(() => localStorage.removeItem(vname));
    },
    clear() {
        safeRun(() => localStorage.clear());
    }
};

export default localStorageStorageSource;
